(() => {
  function enhanceReviews(section) {
    if (section.dataset.cmReviewObserver) return;
    const button = section.querySelector('[data-cm-review-toggle]');
    if (!button) return;
    section.dataset.cmReviewObserver = 'true';
    const update = () => {
      const cards = Array.from(section.querySelectorAll('.vtl-pr-review-card'));
      if (!cards.length) return;
      cards.forEach((card, index) => { card.dataset.cmReviewExtra = index > 2 ? 'true' : 'false'; });
      section.classList.add('cm-story__reviews--enhanced');
      button.hidden = false;
    };
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
      section.classList.toggle('cm-story__reviews--expanded', expanded);
    });
    const observer = new MutationObserver(update);
    observer.observe(section, { childList: true, subtree: true });
    update();
  }
  const initialize = scope => scope.querySelectorAll('.cm-story__reviews').forEach(enhanceReviews);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
